export default __webpack_public_path__ + "static/waerme-60a997b41f0b0f0ea5201f9dd7b487c9.png";